<div [ngClass]="{'fl-filter-container' : !hideSection}">
  <div class="flex flex-wrap gap-4">
    <form [formGroup]="statisticsService.form">
      <div class="flex flex-row flex-wrap w-full">
        <ng-container *ngFor="let input of initData | keyvalue : returnZero">
          <div
            *ngIf="input.value.type != 'checkbox' && input.value.type != 'combobox' && !(input.value.type == 'datepicker' || input.value.type == 'calendar') && !statisticsService.form.controls[input.key]?.disabled && !input.value.hasDeletedToggle"
            class="mr-5 mb-4 flex flex-col w-full sm:w-52">
            <mat-label>
              <span>
                {{
                "reports.form." + (((activeReport === ActiveReportEnum.Reach || activeReport === ActiveReportEnum.Exposures) && input.key === 'screenIds')
                  ? 'screensOrGroups'
                  : input.key)
                | translate
                }}
              </span>
              <span *ngIf="input.value?.isRequired">*</span>
            </mat-label>

            <mat-form-field
              (click)="preventDefault($event)"
              class="collapsed-input inline w-full"
              [ngClass]="{'fade-in':showAnimation&&input.value.formControlName==='mediaFile'}"
              appearance="outline">
              <!-- Dropdown type START -->
              <mat-select
                *ngIf="input.value.type == 'dropdown'"
                [formControlName]="input.value.formControlName"
                [panelClass]="getPanelClass(input.value)"
                [multiple]="input.value.isMultipleDropdown"
                (selectionChange)="onFilterChange(input.value.formControlName)"
                placeholder="{{input.value.label | translate}}">
                <div
                  *ngIf="input.value.hasSelectAll"
                  class="flex items-center p-1 cursor-pointer"
                  (click)="selectAllItems(statisticsService.form, input.value.formControlName)">
                  <app-icon [ngStyle]="{cursor:'pointer'}" size="md" iconName="check"></app-icon>
                  <span class="ml-1">{{'global.selectAll' | translate}}</span>
                </div>
                <mat-divider *ngIf="input.value.hasSelectAll"></mat-divider>
                <div
                  *ngIf="input.value.hasSelectAll && statisticsService.form.get(input.value.formControlName).value?.length"
                  class=" flex items-center p-1 cursor-pointer"
                  (click)="clearAllItems(statisticsService.form, input.value.formControlName)">
                  <app-icon [ngStyle]="{cursor:'pointer'}" size="md" iconName="close"></app-icon>
                  <span class="ml-1">{{'global.deselectAll' | translate}}</span>
                </div>
                <mat-divider *ngIf="input.value.hasSelectAll"></mat-divider>
                <input
                  matInput
                  *ngIf="input.value.search"
                  class="search-input"
                  placeholder="Search"
                  [formControlName]="'searchTerm'+input.value.formControlName"
                  (keydown)="stopEventPropagation($event)" />
                <mat-divider *ngIf="input.value.search"></mat-divider>
                <div
                  *ngIf="input.value.search && input.value.formControlName==='bookingNumber' || input.value.formControlName==='bookingNumbers'"
                  class="flex flex-col px-3 py-2 border-b border-neutral-200">
                  <span class="text-sm">{{'exposures.lastSearchResults' | translate:{count: input.value.data.length} }}</span>
                  <i class="text-xs text-[#595959]">{{ 'exposures.useSearchForMore' | translate }}</i>
                </div>
                <mat-option *ngFor="let data of input.value.filteredData" [value]="data.id">
                  <div
                    id="JSONContainer"
                    *ngIf="!input.value.hasParams"
                    [innerHTML]="input.value.isTranslatable ? (data.name | BoldTextPipe:(data.id === -1)) : data.name | BoldTextPipe:(data.id === -1)"></div>
                  <div id="timeframe" *ngIf="input.value.hasParams">
                    {{ data.name.split('-')[1] ? (data.name.split('-')[0] | translate: { month:
                  data.name.split('-')[1] | translate }) : data.name | translate }}
                  </div>
                </mat-option>
                <div
                  class="flex flex-row px-3 py-2 border-t border-neutral-200"
                  *ngIf="input.value.formControlName === 'bookingNumber'  || input.value.formControlName === 'bookingNumbers'">
                  <a
                    class="cursor-pointer text-sm italic underline text-brand-chathams-blue hover:text-opacity-80"
                    (click)="loadMoreItems()">
                    {{ 'exposures.showMore' | translate }}
                  </a>

                  <a
                    class="ml-3 cursor-pointer text-sm italic underline text-brand-red hover:text-opacity-80"
                    (click)="clearBookingNumberSearch()">
                    {{ 'global.clearSelection' | translate }}
                  </a>
                </div>
              </mat-select>
              <!-- Dropdown type END -->
              <!-- Basic input type START -->
              <input
                *ngIf="input.value.type == 'text'"
                matInput
                [type]="input.value.type"
                [formControlName]="input.value.formControlName" />
              <!-- Basic input type END -->
            </mat-form-field>
            <!-- Calendar type START -->
          </div>
          <div class="mr-5 mb-4 flex flex-col w-full sm:w-52" *ngIf="input.value.type == 'combobox'">
            <flow-form-combobox
              [formControlName]="input.value.formControlName"
              [label]="input.value.label | translate"
              [placeholder]="input.value.label | translate"
              [options]="input.value.comboboxOptions"
              [multiple]="true"
              [selectAll]="input.value.hasSelectAll ?? false"
              [hasSearch]="true"
              [onSearch]="input.value.onSearch"
              [onLoadMore]="input.value.onLoadMore"
              [params]="input.value.comboboxParams"
              [includeInactive]="input.value.comboboxIncludeInactive ?? false"
              [includeInactiveLabel]="input.value.comboboxIncludeInactiveLabel ?? ''">
            </flow-form-combobox>
          </div>
          <div class="mr-5 mb-4 flex flex-col w-full sm:w-52" *ngIf="input.value.type == 'dropdown' && input.value.hasDeletedToggle">
            <flow-select-dropdown-with-status-toggle
              [formControlName]="input.value.formControlName"
              [label]="'reports.form.'+input.key"
              [placeholder]="input.value.label"
              [options]="input.value.filteredData"
              [hasDeletedDisabledDataToggle]="true"
              [includeDeletedDataLabel]="input.value.includeDeletedDataLabel"
              [hasSelectAll]="input.value.hasSelectAll"
              [isRequired]="input.value.isRequired"
              class="block w-full"
              (selectionChange)="onFilterChange(input.value.formControlName)"></flow-select-dropdown-with-status-toggle>
          </div>
          <div
            class="mr-5 mb-4 flex flex-col w-full sm:w-52"
            *ngIf="input.value.type == 'calendar' || (input.value.type == 'datepicker' && ((statisticsService.form.get('timeframe') && statisticsService.form.get('timeframe').value == TimeframeEnum.Custom) || !statisticsService.form.get('timeframe')))">
            <flow-datetime-picker
              [input]="input.value"
              class="block w-full"
              (filterChangeEvent)="onFilterChange($event)"></flow-datetime-picker>
          </div>
          <!-- Calendar type END -->
        </ng-container>
      </div>
      <!-- Checkbox type START -->
      <div class="flex flex-wrap flex-row">
        <ng-container *ngFor="let input of initData | keyvalue : returnZero">
          <mat-checkbox
            *ngIf="input.value.type == 'checkbox'"
            class="checkbox mb-4"
            color="primary"
            [formControlName]="input.value.formControlName"
            (change)="onFilterChange(input.value.formControlName)">
            {{ input.value.label | translate }}
          </mat-checkbox>
        </ng-container>
      </div>
      <!-- Checkbox type END -->
      <mat-checkbox
        *ngIf="!isInFolder && showFolder"
        [checked]="isChecked"
        color="primary"
        class="mr-3 show-folder-class"
        (change)="_showHideFolderClick($event)">
        {{'media.showFolders' | translate}}
      </mat-checkbox>
    </form>
  </div>
  <div class="flex mt-6" [ngClass]="{'gap-4': !downloadReportDisableBtn}" *ngIf="!hideSection">
    <ng-container *ngIf="!downloadReportDisableBtn">
      <flow-button *flowHasPermission="permissions; disabled true;" theme="tetriary" variation="fill" (onClick)="downloadReport()">
        <app-icon fill="none" [stroke]="'#fff'" iconName="download-02" size="md"></app-icon>
        .xls
      </flow-button>
    </ng-container>

    <flow-button
      theme="primary"
      variation="fill"
      (onClick)="createReport()"
      [ngClass]="!statisticsService.form.valid ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'">
      <app-icon fill="none" [stroke]="'#fff'" iconName="file-check-02" size="md"></app-icon>
      {{ "global.create" | translate }}
    </flow-button>
  </div>
</div>
